export default {
  confirmDelete: 'Datei "{0}" löschen?',
  emptyMessage: 'Keine {0} verfügbar.',
  uploadButtonLabel: '{0} hochladen',
  files: 'Dateien',
};
